export default __webpack_public_path__ + "static/media/AG.f3c7b048.svg";